// @ts-nocheck TODO

import {LitElement, html} from "lit";
import {customElement, query, state} from "lit/decorators.js";

import "../../common/controls-inputs/Button.js";
import "../../common/controls-inputs/LabeledTextInput.js";
import {restoreSessionStyles} from "./RestoreSession.styles.js";
import Utils from "../../../main/utils/index.js";
import Data from "../../../main/data/index.js";
import Integration from "../../../integrations/integration/index.js";

@customElement("pn-restore-session")
export class RestoreSession extends LitElement {
	@state() _emailError = "";
	@state() _emailSubmitted = false;
	@state() _isEmailError = false;

	@query("#email-input") _emailInput: HTMLElement;

	static styles = [restoreSessionStyles];

	onClickSubmit = async () => {
		if (!Integration.isIntegration())
			throw new Error("Not an integration");

		if (!Data.app.me)
			throw new Error("Not logged in");

		let email = this._emailInput.shadowRoot.querySelector("input").value;
		email = email.trim();

		if (email === "")
			this._isEmailError = true;
		else if (!Utils.Common.isValidEmail(email)) {
			this._isEmailError = true;
			this._emailError = "Invalid email address.";
		} else {
			// TODO: error handling (try-catch)
			await Data.app.backend.callApi({
				url:    `integration/${Integration.name}/login-code`,
				method: "POST",
				body:   {
					account_uuid: Data.app.me.uuid,
					email
				},
				expectedStatusCode: 204,
				isJsonBody:         true
			});

			this._emailSubmitted = true;
			this._isEmailError = false;
			this._emailError = "";
		}
	};

	onClickReturn = () => {
		const myEvent = new CustomEvent("closeRestoreSession", {
			bubbles:  true,
			composed: true
		});

		this.dispatchEvent(myEvent);
	};

	render() {
		if (this._emailSubmitted) {
			return html`
				<div id="view-submitted">
					<div id="img-wrapper">
						<img src="${Utils.Common.imgPath("restore-session-check.svg")}" alt="Green check mark" role="img" />
						<img id="img-shadow" src="${Utils.Common.imgPath("restore-session-shadow.svg")}" alt="Shadow" role="img" />
					</div>

					<h1>Check your email for your temporary code.</h1>

					<pn-button
						@click="${this.onClickReturn}"
						id="btn-return"
						renderType="purple"
					>Return To Outline</pn-button>
				</div>
			`;
		} else {
			return html`
				<div id="view-enter-email">
					<h1>Enter your email address to continue your session later.</h1>

					<div id="instructions">By entering your email we send an email with an auto-generated code that restores the session with the same temporary account.</div>

					<pn-labeled-text-input
						.errorMessage="${this._emailError}"
						id="email-input"
						.inputType="${"email"}"
						.isError="${this._isEmailError}"
						.label="${"Enter Email:"}"
						.required="${true}"
					></pn-labeled-text-input>

					<div id="btn-group">
						<pn-button
							.onClick="${this.onClickReturn}"
							renderType="secondary"
						>Cancel</pn-button>
						<pn-button
							.onClick="${this.onClickSubmit}"
							renderType="purple"
						>Submit</pn-button>
					</div>
				</div>
			`;
		}
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-restore-session": RestoreSession;
	}
}
